var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChipFramedWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.25px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconChipFramedWall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FramedWall"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 14.52 38.57 13.34 38.57 12.32 36.45 13.51 36.45 14.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 14.52 36.45 13.51 27.04 10.13 27.04 11.14 36.45 14.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 13.51 38.57 12.32 29.16 8.94 27.04 10.13 36.45 13.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.63 7.75 17.63 6.74 8.22 3.35 8.22 4.36 17.63 7.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.63 6.74 19.75 5.55 10.34 2.16 8.22 3.35 17.63 6.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.04 11.14 27.04 10.13 17.63 6.74 17.63 7.75 27.04 11.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.04 10.13 29.16 8.94 19.75 5.55 17.63 6.74 27.04 10.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.63 39.06 17.63 38.05 8.22 34.66 8.22 35.67 17.63 39.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.19 37.89 17.19 35.94 11.22 33.79 9.1 34.98 11.22 35.75 17.19 37.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.04 42.45 27.04 41.44 17.63 38.05 17.63 39.06 27.04 42.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.6 41.28 26.6 39.33 20.19 37.02 18.07 38.21 20.19 38.97 26.6 41.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 45.84 38.57 44.65 38.57 43.64 36.45 44.83 36.45 45.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 45.84 36.45 44.83 27.04 41.44 27.04 42.45 36.45 45.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.56 44.51 35.56 42.56 29.6 40.41 27.48 41.6 29.6 42.36 35.56 44.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 44.83 36.45 14.52 35.56 14.21 35.56 44.51 36.45 44.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.45 44.83 38.57 43.64 38.57 13.34 36.45 14.52 36.45 44.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.1 34.98 9.1 4.68 8.22 4.36 8.22 34.66 9.1 34.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.1 34.98 11.22 33.79 11.22 5.44 9.1 4.68 9.1 34.66 9.1 34.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.07 38.21 18.07 7.91 17.19 7.59 17.19 37.89 18.07 38.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.07 38.21 20.19 37.02 20.19 8.67 18.07 7.91 18.07 38.05 18.07 38.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.48 41.6 27.48 11.29 26.6 10.98 26.6 41.28 27.48 41.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.48 41.6 29.6 40.41 29.6 12.06 27.48 11.29 27.48 41.44 27.48 41.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 13.51,
    x2: 36.45,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 14.52,
    x2: 38.57,
    y2: 13.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.57,
    y1: 13.34,
    x2: 38.57,
    y2: 12.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.57,
    y1: 12.33,
    x2: 36.45,
    y2: 13.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 13.51,
    x2: 27.04,
    y2: 10.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.04,
    y1: 11.14,
    x2: 36.45,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.16,
    y1: 8.94,
    x2: 38.57,
    y2: 12.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 3.35,
    x2: 10.34,
    y2: 2.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 4.36,
    x2: 8.22,
    y2: 3.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.63,
    y1: 6.74,
    x2: 8.22,
    y2: 3.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 4.36,
    x2: 17.63,
    y2: 7.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.34,
    y1: 2.16,
    x2: 19.75,
    y2: 5.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.04,
    y1: 10.13,
    x2: 17.63,
    y2: 6.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.63,
    y1: 7.75,
    x2: 27.04,
    y2: 11.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.75,
    y1: 5.55,
    x2: 29.16,
    y2: 8.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 35.67,
    x2: 8.22,
    y2: 34.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 35.67,
    x2: 17.63,
    y2: 39.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.63,
    y1: 38.05,
    x2: 8.22,
    y2: 34.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.19,
    y1: 35.94,
    x2: 11.22,
    y2: 33.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.63,
    y1: 39.06,
    x2: 27.04,
    y2: 42.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.04,
    y1: 41.44,
    x2: 17.63,
    y2: 38.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.6,
    y1: 39.33,
    x2: 20.19,
    y2: 37.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 45.84,
    x2: 38.57,
    y2: 44.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.57,
    y1: 44.65,
    x2: 38.57,
    y2: 43.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.57,
    y1: 43.64,
    x2: 36.45,
    y2: 44.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 44.83,
    x2: 36.45,
    y2: 45.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.04,
    y1: 42.45,
    x2: 36.45,
    y2: 45.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 44.83,
    x2: 27.04,
    y2: 41.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.56,
    y1: 42.56,
    x2: 29.6,
    y2: 40.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 44.83,
    x2: 35.56,
    y2: 44.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.57,
    y1: 43.64,
    x2: 36.45,
    y2: 44.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 14.52,
    x2: 38.57,
    y2: 13.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.56,
    y1: 14.21,
    x2: 36.45,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.45,
    y1: 44.83,
    x2: 36.45,
    y2: 14.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.56,
    y1: 14.21,
    x2: 35.56,
    y2: 44.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.57,
    y1: 13.34,
    x2: 38.57,
    y2: 43.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 4.36,
    x2: 9.1,
    y2: 4.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.22,
    y1: 33.79,
    x2: 9.1,
    y2: 34.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 9.1,
    y1: 34.98,
    x2: 8.22,
    y2: 34.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.22,
    y1: 4.36,
    x2: 8.22,
    y2: 34.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 9.1,
    y1: 34.98,
    x2: 9.1,
    y2: 4.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.22,
    y1: 33.79,
    x2: 11.22,
    y2: 5.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.07,
    y1: 38.21,
    x2: 17.19,
    y2: 37.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.19,
    y1: 37.02,
    x2: 18.07,
    y2: 38.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.19,
    y1: 7.59,
    x2: 18.07,
    y2: 7.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.07,
    y1: 38.21,
    x2: 18.07,
    y2: 7.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.19,
    y1: 7.59,
    x2: 17.19,
    y2: 37.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.19,
    y1: 8.67,
    x2: 20.19,
    y2: 37.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.48,
    y1: 41.6,
    x2: 26.6,
    y2: 41.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.6,
    y1: 40.41,
    x2: 27.48,
    y2: 41.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.6,
    y1: 10.98,
    x2: 27.48,
    y2: 11.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.48,
    y1: 41.6,
    x2: 27.48,
    y2: 11.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.6,
    y1: 10.98,
    x2: 26.6,
    y2: 41.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.6,
    y1: 12.06,
    x2: 29.6,
    y2: 40.41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChipFramedWall);
export default __webpack_public_path__ + "static/media/IconChipFramedWall.9b6020dc175ff4338e815ee984d925c7.svg";
export { ForwardRef as ReactComponent };